/**
 * 시딩 캠페인 신청/수락 시 BE 가 "동시 진행 가능 캠페인 수(10개) 초과" 를 알리는 에러 코드.
 * 이 코드를 받으면 일반 토스트가 아니라 "진행 중인 캠페인을 확인해 주세요." 다이얼로그
 * (RecruitApplyValidationDialog 의 OVER_LIMIT 케이스, Figma node 1476-31954) 를 노출한다.
 *
 * - COMMON-001-003: 기존(제안형 수락 등) over-limit 코드.
 * - SEEDING-001-009: 모집형 신청 over-limit 신규 코드 (BE 0618, 코드 분리로 '이미 신청'(008)과 구분 가능).
 * 둘 다 동일하게 over-limit 으로 처리한다.
 */
export const ERROR_CODE_SEEDING_CAMPAIGN_OVER_LIMIT = 'COMMON-001-003';
export const ERROR_CODE_SEEDING_APPLY_OVER_LIMIT = 'SEEDING-001-009';

const OVER_LIMIT_ERROR_CODES = new Set<string>([
  ERROR_CODE_SEEDING_CAMPAIGN_OVER_LIMIT,
  ERROR_CODE_SEEDING_APPLY_OVER_LIMIT,
]);

/**
 * mutation onError 로 들어온 에러가 "캠페인 10개 초과(COMMON-001-003 / SEEDING-001-009)" 인지 판정한다.
 *
 * non-2xx HTTP 응답만 대상으로 한다. `executeStandardRequest` 가 non-2xx 를
 * `{ data, status, message }` 평문 객체로 reject 하며, BE 실제 errorCode 는
 * `error.data.meta.errorCode` 경로에 담긴다. (200 + `meta.result==='FAIL'` 경로는
 * service 가 `new Error(message)` 로 throw 하며 errorCode 를 보존하지 않으므로 대상 외.)
 *
 * NOTE: `@musinsa/services-curator` 의 `isApiError` 와 동일한 판정이지만, 순수 util 이
 * 무거운 service barrel(transitive ESM) 에 결합되지 않도록 [[resolveMutationErrorMessage]]
 * 와 동일하게 동일 shape 의 가드를 인라인한다.
 */
export const isSeedingCampaignOverLimitError = (error: unknown): boolean => {
  if (typeof error !== 'object' || error === null || !('data' in error)) return false;
  const { data } = error as { data?: unknown };
  if (typeof data !== 'object' || data === null || !('meta' in data)) return false;
  const { meta } = data as { meta?: unknown };
  if (typeof meta !== 'object' || meta === null || !('errorCode' in meta)) return false;
  const { errorCode } = meta as { errorCode?: unknown };
  return typeof errorCode === 'string' && OVER_LIMIT_ERROR_CODES.has(errorCode);
};
